export const pinterestPinItMetaData = {
    isRepeatable: false
}
